import { noop } from "@aircall/tractor";

import { useHasReadLinePermission } from "@/hooks/useHasReadLinePermission/useHasReadLinePermission";

import {
  getNumberSettingsRoute,
  redirectToDashboard,
} from "@/helpers/navigation/navigation.helpers";
import { useGetLine } from "../useGetLine/useGetLine";

export function useUpdateLineSettings() {
  const { line } = useGetLine();

  const hasReadLinePermission = useHasReadLinePermission();

  if (!line || !hasReadLinePermission) {
    return noop;
  }

  return () => {
    redirectToDashboard(getNumberSettingsRoute(line.ID));
  };
}
